import { SearchablePart } from '@components/Product/Desktop/Panels/PartsCatalogue/Autocomplete';
import { useTranslation } from 'react-i18next';
import Chip from 'src/components/Chip';
import { Highlight } from 'src/components/Product/Mobile/Panels/PartsCatalogue/Autocomplete/Highlight';
import {
  BlockLi,
  FlexSpaceBetween,
  SmallCapitalized,
} from 'src/components/Product/Mobile/Panels/PartsCatalogue/Autocomplete/styles';

interface SearchOptionProps {
  readonly searchablePart: SearchablePart;
  readonly regex: RegExp;
  readonly props: React.HTMLAttributes<HTMLLIElement>;
  readonly showKitChip?: boolean;
}

/* istanbul ignore next */
export default function SearchOption({ searchablePart, regex, props, showKitChip }: Readonly<SearchOptionProps>) {
  const {
    part: { name, id },
    group,
    partNumber,
    active,
  } = searchablePart;

  return (
    <BlockLi data-testid="bom-filter-result" {...props}>
      <Highlight text={name} regex={regex} />
      {searchablePart.partNumber &&
        !showKitChip &&
        !active && ( // Display chip only for outdated supersessions (For some reason active part is also on the list)
          <Chip size="small" label="Outdated" style={{ marginLeft: 10 }} />
        )}

      {showKitChip && <KitChip />}

      <FlexSpaceBetween>
        <Highlight text={partNumber ?? id} regex={regex} />
        {group?.name && <SmallCapitalized>In {group.name.toLowerCase()}</SmallCapitalized>}
      </FlexSpaceBetween>
    </BlockLi>
  );
}

function KitChip() {
  const { t } = useTranslation('partsCatalogue');
  return (
    <Chip
      size="small"
      label={t('kitSection.kit_one')}
      sx={{
        backgroundColor: 'primary.main',
        color: 'primary.contrastText',
        marginLeft: 1,
      }}
    />
  );
}
